import { CountdownButton, type CountdownButtonProps } from "@picklebet/ui";
import React from "react";

import * as styles from "./OtpVerification.module.scss";
import type { OtpFlowName } from "../utils/types";
import { differenceInSeconds } from "date-fns/differenceInSeconds";
import { VerifiedPill } from "./VerifiedPill";
import { useOtpFlow } from "../hooks/useOtpFlow";
import { AnimatePresence } from "motion/react";

type RetryButtonProps = {
  flow: OtpFlowName;
  isEnabled: boolean;
  destination?: string;
  label?: string;
} & Partial<CountdownButtonProps>;

export const RetryButton = (props: RetryButtonProps) => {
  const { store } = useOtpFlow(props.flow);

  const status = store((s) => s.status);
  const session = store((s) => s.session);
  const clearRetryTimer = store((s) => s.clearRetryTimer);

  if (!props.isEnabled) return;

  const retryAfter = session?.retryAfter ?? null;
  const retrySeconds = retryAfter
    ? differenceInSeconds(retryAfter, new Date(), { roundingMethod: "ceil" })
    : 0;

  return (
    <AnimatePresence mode="sync">
      {status === "verified" && session?.destination ? (
        <VerifiedPill />
      ) : (
        <CountdownButton
          className={styles.verifyButton}
          size="sm"
          loading={props.loading}
          variant={props.variant}
          disabled={props.disabled || props.loading}
          startCountdown={retrySeconds > 0}
          duration={retrySeconds}
          initialLabel={props.label}
          countingLabel={(time) => `Resend in ${time}`}
          finishedLabel={props.label}
          finishedVariant={props.variant}
          onExpire={clearRetryTimer}
          onClick={props.onClick}
        />
      )}
    </AnimatePresence>
  );
};
